import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, requireSovereign = false, allowedRoles = null }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-armada-base">
        <div className="text-gold tracking-armada text-xs">INITIALIZING SOVEREIGN COMMAND...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireSovereign && user.role !== "sovereign") {
    return <Navigate to="/dashboard" replace />;
  }
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

export function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}
